"use client";

import { Pause, Play } from "lucide-react";
import { Button } from "../buttons";

export type CreatorVideoControlsProps = {
  isPlaying: boolean;
  onTogglePlayAction: () => void;
};

/**
 * Renders the play/pause button for the modal footer.
 */
export const CreatorVideoControls = ({
  isPlaying,
  onTogglePlayAction,
}: CreatorVideoControlsProps) => (
  <Button
    type="button"
    variant="text"
    aria-label={isPlaying ? "Pause video" : "Play video"}
    onClick={onTogglePlayAction}
    className="z-50 inline-flex items-center justify-center select-none"
  >
    {isPlaying ? (
      <Pause className="h-7! w-7! fill-white text-white transition-transform duration-150 hover:scale-105 active:scale-95" />
    ) : (
      <Play className="h-7! w-7! fill-white text-white transition-transform duration-150 hover:scale-105 active:scale-95" />
    )}
  </Button>
);
